<template>
  <v-row dense>
    <v-col>
      <v-row align="center">
        <authorization
          permissionKey="attendance_medical_certificate"
          can="print"
          v-slot:default="{ authorization }"
        >
          <v-col cols="3" v-if="authorization">
            <MedicalCertificateButton
              :attendance="attendance"
              medicalCertificateType="comparecimento"
              :newMedicalCertificate="true"
              v-slot:default="{ textColor }"
            >
              <v-row dense>
                <v-col>
                  <v-icon :color="textColor">
                    mdi-file-outline
                  </v-icon>
                </v-col>
              </v-row>

              <v-row dense>
                <v-col>
                  Comparecimento
                </v-col>
              </v-row>
            </MedicalCertificateButton>
          </v-col>
        </authorization>

        <authorization
          v-if="allowCreate"
          permissionKey="attendance_medical_certificate"
          can="save"
          v-slot:default="{ authorization }"
        >
          <v-col cols="3" v-if="authorization">
            <MedicalCertificateButton
              :attendance="attendance"
              medicalCertificateType="afastamento"
              :newMedicalCertificate="true"
              v-slot:default="{ textColor }"
            >
              <v-row dense>
                <v-col>
                  <v-icon :color="textColor">
                    mdi-bed-outline
                  </v-icon>
                </v-col>
              </v-row>

              <v-row dense>
                <v-col>
                  Afastamento
                </v-col>
              </v-row>
            </MedicalCertificateButton>
          </v-col>
        </authorization>

        <authorization
          v-if="allowCreate"
          permissionKey="attendance_medical_certificate"
          can="save"
          v-slot:default="{ authorization }"
        >
          <v-col cols="3" v-if="authorization">
            <MedicalCertificateButton
              :attendance="attendance"
              medicalCertificateType="acompanhante"
              :newMedicalCertificate="true"
              v-slot:default="{ textColor }"
            >
              <v-row dense>
                <v-col>
                  <v-icon :color="textColor">
                    mdi-account-multiple-outline
                  </v-icon>
                </v-col>
              </v-row>

              <v-row dense>
                <v-col>
                  Acompanhante
                </v-col>
              </v-row>
            </MedicalCertificateButton>
          </v-col>
        </authorization>

        <authorization
          permissionKey="attendance_medical_certificate"
          can="print"
          v-slot:default="{ authorization }"
        >
          <v-col cols="3" v-if="authorization">
            <MedicalCertificateButton
              :attendance="attendance"
              medicalCertificateType="detran"
              :newMedicalCertificate="true"
              v-slot:default="{ textColor }"
            >
              <v-row dense>
                <v-col>
                  <v-icon :color="textColor">
                    mdi-truck-outline
                  </v-icon>
                </v-col>
              </v-row>

              <v-row dense>
                <v-col>
                  Detran
                </v-col>
              </v-row>
            </MedicalCertificateButton>
          </v-col>
        </authorization>
      </v-row>

      <v-row v-if="!lodash.isEmpty(medicalCertificates)">
        <v-col class="text-h5 gray--text">
          Ultimos Atestados
        </v-col>
      </v-row>

      <v-row
        dense
        v-for="(medicalCertificate, index) in medicalCertificates"
        :key="medicalCertificate.id"
      >
        <v-col>
          <MedicalCertificateListItem
            :medicalCertificate="medicalCertificate"
            :index="index"
            :refreshList="refreshList"
            :allowEdit="allowEdit"
            :allowDelete="allowDelete"
          />
        </v-col>
      </v-row>
    </v-col>
  </v-row>
</template>

<script>
  import MedicalCertificateListItem from "@/components/medical_certificates/list/item.vue";
  import MedicalCertificateButton from "@/components/medical_certificates/button.vue";

  export default {
    name: "MedicalCertificateList",
    props: {
      attendance: Object,
      allowEdit: {
        type: Boolean,
        default: true,
      },
      allowDelete: {
        type: Boolean,
        default: true,
      },
      allowCreate: {
        type: Boolean,
        default: true,
      },
    },
    components: {
      MedicalCertificateListItem,
      MedicalCertificateButton,
    },
    mounted(){
      this.refreshList();
    },
    apollo: {
      medicalCertificates: {
        query: require("@/graphql/medical_certificate/medical_certificates.gql"),
        variables() {
          return {
            attendanceId: this.attendance.id,
          };
        },
        update(data) {
          return this.lodash.orderBy(data.medicalCertificates, ["createdAt"], ["asc"]);
        },
        pollInterval: 200000,
      },
    },
    methods: {
      async refreshList() {
        await this.$apollo.queries.medicalCertificates.refetch();
      },
    },
  };
</script>

<style lang="scss" scoped></style>
